import React, { useState, useEffect } from 'react';
import { message, Modal, } from 'components/shared/AntComponent';
import { Input, Button, Select, Form, InputNumber } from 'components/shared/FormComponent';
import { MinusCircleOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { deleteCourseSpec, getCourse, getGroup, getSpecialisation, getSubject, saveCourse, saveGroup, saveSpecialisation, saveSubject, saveSyllabus } from 'services/store/actions/masterDataAction';
import { useSelector } from 'react-redux';

interface ChildProps {
    openModal: boolean;
    closeModal: () => void;
    callbackFunc: () => void;
    rowData: any;
    requestFrom: number;
    modalTitle: string;
}

const AddDegreeSpecialisationModal: React.FC<ChildProps> = ({ openModal, closeModal, callbackFunc, rowData, requestFrom, modalTitle }) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { loading9, success9, error9, loading13, error13, success13, loading16, error16, success16, success19, error19, loading19, loading27,
        categoryInfo, loading18, specialisationInfo, loading12, courseInfo, loading21, loading26, success26, error26, subjectInfo, loading15
    } = useSelector((state: any) => state.master);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success9 || success13 || success16 || success19 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error9 || error13 || error16 || error19 : false;
    const [showSuccessmsg1, setShowSuccessmsg1] = useState(false);
    const successmsg1 = showSuccessmsg1 ? success26 : false;
    const [showErrormsg1, setShowErrormsg1] = useState(false);
    const errormsg1 = showErrormsg1 ? error26 : false;
    const [errorMessage, setErrorMessage] = useState("");
    const [delSpecID, setDelSpecID]: any = useState(null);
    const [ctype, setCtype] = useState('');
    const [specializeOption, setSpecializeOption] = useState([]);
    const [subjectOption, setSubjectOption] = useState([]);
    const [removeSpecID, setRemoveSpecID]: any = useState([]);
    const [removeSubjectID, setRemoveSubjectID]: any = useState([]);

    const courseOptions = !loading21 && courseInfo?.data?.map((item: any) => ({
        label: item?.courseName,
        value: item?.masCourseID
    }))

    const categoryOptions = !loading18 && categoryInfo?.data?.map((item: any) => ({
        label: item?.groupName,
        value: item?.groupID,
    }));
    const subjectOptions = !loading15 && subjectInfo?.data?.map((item: any) => ({
        value: item?.masSubjectID,
        label: item?.subjectName,
        description: item?.description,
        shortName: item?.subShortName,
        subjectCode: item?.subjectCode,
        subjectStatus: item?.subjectStatus
    }));

    const specOptions = !loading12 && specialisationInfo?.data?.map((item: any) => ({
        value: item?.specializationId,
        label: item?.specializationName,
        id: item?.specializationId,
        description: item.description,
        actualID: 0
    }));

    const statusOption = [
        { value: "active", label: 'Active' },
        { value: "inactive", label: "Inactive" }
    ];

    const statusOption2 = [
        { value: 'Public', label: 'Public' },
        { value: 'Academic', label: 'Academic' }
    ];

    const durationOption = [
        { value: "Month", label: "Month" },
        { value: "Week", label: "Week" },
        { value: "Year", label: "Year" }
    ];

    useEffect(() => {
        if (specialisationInfo?.data) {
            const specOptions = !loading12 && specialisationInfo?.data?.map((item: any) => ({
                value: item?.specializationId,
                label: item?.specializationName,
                id: item?.specializationId,
                description: item.description,
                actualID: 0
            }));
            setSpecializeOption(specOptions);
        }
    }, [specialisationInfo]);

    useEffect(() => {
        if (subjectInfo?.data) {
            const subjectOptions = !loading15 && subjectInfo?.data?.map((item: any) => ({
                value: item?.masSubjectID,
                label: item?.subjectName,
                description: item?.description,
                shortName: item?.subShortName,
                subjectCode: item?.subjectCode,
                subjectStatus: item?.subjectStatus,
                actualID: 0
            }));
            setSubjectOption(subjectOptions);
        }
    }, [subjectInfo]);

    const handleCancel = () => {
        closeModal();
    }

    const submitForm = async () => {
        try {
            const value = await form.validateFields();
            if (requestFrom == 1) {
                const inputJson = {
                    "SpecializationId": rowData?.specializationId || 0,
                    "SpecializationName": value?.specialisationName || "",
                    "Description": value?.description || "",
                    "IsActive": rowData ? value.status === "active" ? true : false : true,
                    "TenantId": Number(localStorage.getItem('tenantID')),
                }
                dispatch(saveSpecialisation(inputJson) as any);
            } else if (requestFrom == 2) {
                const inputJson = {
                    "MasSubjectID": rowData?.masSubjectID || 0,
                    "SubjectName": value?.subjectName || "",
                    "SubShortName": value?.subjectShortName || "AI",
                    "SubjectStatus": rowData? value.status==="active"?"Active":"Inactive":"Active",
                    "Description": value?.description || "",
                    "IsActive": rowData ? value.status === "active" ? true : false : true,
                    "TenantId": Number(localStorage.getItem('tenantID'))
                }
                dispatch(saveSubject(inputJson) as any);
            } else if (requestFrom == 3) {
                const inputJson = {
                    "GroupId": rowData?.groupID || 0,
                    "GroupName": value?.groupName || "",
                    "GroupDesc": value?.description || "",
                    "GroupType": value?.type || "",
                    "IsActive": rowData ? value.status === "active" ? true : false : true,
                    "TenantId": Number(localStorage.getItem('tenantID'))
                }
                dispatch(saveGroup(inputJson) as any);
            } else if (requestFrom == 4) {
                let spec1: any = [];
if (ctype?.toLowerCase() === "public"){

                    const matchedSpec: any = specializeOption?.find(
                        (item: any) => item.value == value?.specialisation?.toString()
                    );

                    if (matchedSpec) {
                        spec1.push({
                            SpecializationId: matchedSpec?.actualID || 0,
                            SpecializationName: matchedSpec.label,
                            Description: matchedSpec.description,
                            MasSpecializationId: Number(matchedSpec.value)
                        });
                    }
                }
                else {
const specValues = Array.isArray(value?.specialisation)
    ? value.specialisation
    : [value.specialisation];

const Specialization = specValues
    .map((selectedName: any) => {
        const matchedSpec: any = specializeOption?.find(
            (item: any) => item.value === selectedName
        );

        return matchedSpec
            ? {
                  SpecializationId: matchedSpec?.actualID || 0,
                  SpecializationName: matchedSpec?.label,
                  Description: matchedSpec?.description,
                  MasSpecializationId: Number(matchedSpec?.value),
              }
            : null;
    })
    .filter((item: any) => item !== null);

spec1 = Specialization;
                }
                const Subject = value?.subject.map((selectedName: any) => {
                    const matchedSpec: any = subjectOption?.find((item: any) => item.value === selectedName);
                    return matchedSpec ? {
                        "SubjectID": matchedSpec?.actualID || 0,
                        "masSubjectID": matchedSpec.value,
                        "subjectCode": matchedSpec.subjectCode || "",
                        "subjectName": matchedSpec.label || "",
                        "subShortName": matchedSpec.shortName || "",
                        "subjectStatus": matchedSpec.subjectStatus || "",
                        "description": matchedSpec.description || ""
                    } : null;
                }).filter((item: any) => item !== null);
                const inputJson = {
                    "MasCourseID": rowData?.masCourseID || 0,
                    "CourseName": value?.courseName || "",
                    "CourseType": value?.type || "",
                    "GroupID": value?.category || null,
                    "GroupName": value?.category ? categoryOptions?.find((item: any) => item.value === value?.category)?.label || "" : "",
                    "DurationCount": value?.duration || null,
                    "DurationName": value?.period || "",
                    "CourseDescription": value?.description || "",
                    "TenantId": Number(localStorage.getItem('tenantID')),
                    "Subjects": value.subject ? Subject : null,
                    "Specialization": value?.specialisation ? spec1 : null,
                    "RSpeczIds": removeSpecID?.toString() || "",
                    "RSubjectIds": removeSubjectID?.length == 0 ? "" : removeSubjectID?.toString() || "",
                    "IsActive": rowData ? value.status === "active" ? true : false : true,
                }
                dispatch(saveCourse(inputJson) as any);
            } else {
                const inputJson = {
                    "SyllabusID": 0,
                    "Title": value?.syllabusTitle || "",
                    "UnitNo": value?.unitNo || 1,
                    "Notes": value?.description || "",
                    "SubjectID": value?.subject,
                    "SubjectName": value?.subject ? subjectOptions?.find((item: any) => item.value == value?.subject)?.label : "",
                    "CourseID": value?.course,
                    "CourseName": value?.course ? courseOptions?.find((item: any) => item.value == value?.course)?.label : "",
                    "TenantID": Number(localStorage.getItem('tenantID'))
                }
                dispatch(saveSyllabus(inputJson) as any);

            }

            setShowSuccessmsg(true);
            setShowErrormsg(true);
        } catch (e: any) {
            console.log("error", e);
        }
    }

    useEffect(() => {
        if (openModal && rowData) {
            setErrorMessage("");
            if (requestFrom == 1) {
                form.setFieldsValue({
                    "specialisationName": rowData?.specializationName,
                    "description": rowData?.description,
                    "status": rowData?.isActive ? 'active' : 'inactive'
                })
            } else if (requestFrom == 2) {
                form.setFieldsValue({
                    "subjectName": rowData?.subjectName,
                    "subjectShortName": rowData?.subShortName || "",
                    "description": rowData?.description,
                    "type": "",
                    "status": rowData?.isActive ? 'active' : 'inactive'
                })
            }
            else if (requestFrom == 3) {
                form.setFieldsValue({
                    "groupName": rowData?.groupName,
                    "description": rowData?.groupDesc,
                    "type": rowData?.groupType || "",
                    "status": rowData?.isActive ? 'active' : 'inactive'
                })
            } else {
                form.setFieldsValue({
                    "courseName": rowData?.courseName,
                    "type": rowData?.courseType,
                    "duration": rowData?.durationCount,
                    "period": rowData?.durationName,
                    "category": rowData?.groupID,
                    "description": rowData?.courseDescription,
                    "status": rowData?.isActive ? 'active' : 'inactive'
                })
                setCtype(rowData?.courseType);
                setRemoveSpecID([]);
                setRemoveSubjectID([]);
            }

        } else {
            if (openModal) {
form.resetFields();
form.setFieldsValue({
    type: "Academic"
});
setCtype("Academic");
setErrorMessage("");
            }

        }
    }, [openModal, rowData]);

    useEffect(() => {
        if (
            rowData &&
            openModal &&
            courseInfo?.data?.length > 0 &&
            specializeOption?.length &&
            subjectInfo?.data?.length

        ) {
            const specializationMap = courseInfo?.data?.[0]?.specialization?.reduce((acc: any, item: any) => {
                acc[item.masSpecializationId] = item; // store full specialization object
                return acc;
            }, {}) || {};

            const subjectMap = courseInfo?.data?.[0]?.subjects?.reduce((acc: any, item: any) => {
                acc[item.masSubjectID] = item; // store full specialization object
                return acc;
            }, {}) || {};

            // Update specializeOption array with the actualID based on matching masSpecializationId
            const updatedSpecializeOption: any = specializeOption.map((item: any) => {
                const matchedSpec = specializationMap[item.value];
                return {
                    ...item,
                    value: matchedSpec?.masSpecializationId ?? item.value,
                    actualID: matchedSpec?.specializationId ?? 0, // Update actualID with specializationId or keep existing if not found
                }
            });

            const updatedSubjectOption: any = subjectOption.map((item: any) => {
                const matchedSpec = subjectMap[item.value];
                return {
                    ...item,
                    value: matchedSpec?.masSubjectID ?? item.value,
                    actualID: matchedSpec?.subjectID ?? 0, // Update actualID with specializationId or keep existing if not found
                }
            });
            setSpecializeOption(updatedSpecializeOption);
            setSubjectOption(updatedSubjectOption || subjectOption);
        }
    }, [courseInfo?.data, rowData, specialisationInfo, subjectInfo]);

    useEffect(() => {
        if (rowData && openModal && courseInfo?.data) {
            form.setFieldsValue({
                "specialisation": courseInfo.data?.[0].specialization.map((item: any) => item.masSpecializationId),
                "subject": courseInfo.data?.[0].subjects?.map((item: any) => item.masSubjectID),
            });
        }
    }, [rowData, openModal, courseInfo])

    useEffect(() => {
        if (successmsg) {
            message.success(`${requestFrom === 1 ? "Specialisation" : requestFrom === 2 ? "Subject" : requestFrom == 3 ? "Category" : "Course"} ${rowData ? "updated " : "created "}successfully`);
            setShowSuccessmsg(false);
            closeModal();
            callbackFunc();
        }
        if (errormsg) {
            if (error9?.message) {
                message.error(error9?.message);
            } else if (error13) {
                message.error(error13?.message);
            } else if (error16) {
                message.error(error16?.message);
            } else if (error19) {
                message.error(error19?.message);
            } else {
                message.error(`${requestFrom === 1 ? "Specialisation" : requestFrom === 2 ? "Subject" : requestFrom == 3 ? "Category" : "Course"} couldn't be ${rowData ? "updated " : "created "}`);
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    const getGroupDetails = () => {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getGroup(id) as any);
    }

    const getSpecialisationDetails = () => {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getSpecialisation(id) as any);
    }

    const getSubjectDetails = () => {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getSubject(id) as any);
    }

    const getCourseDetails = () => {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getCourse(id) as any);
    }

    useEffect(() => {
        if (requestFrom == 4 && openModal) {
            getGroupDetails();
            getSpecialisationDetails();
            getSubjectDetails();
        }
    }, [requestFrom, openModal]);

    useEffect(() => {
        if (requestFrom == 5 && openModal) {
            getCourseDetails();
            getSubjectDetails();
        }

    }, [requestFrom, openModal]);

    const handleDeselectSpec = (e: string) => {
        const val = courseInfo?.data?.[0]?.specialization?.map((item: any) => item.masSpecializationId);
        if (rowData && val?.includes(e)) {
            const val1 = courseInfo?.data?.[0]?.specialization.find((item: any) => item.masSpecializationId == e)?.specializationId;
            if (!removeSpecID?.includes(val1)) {
                setRemoveSpecID((prev: any) => {
                    if (prev?.includes(val1)) return prev;
                    return [...prev, val1];
                });
            }
        }
    }

    useEffect(() => {
        if (successmsg1) {
            setDelSpecID(null);
            setShowSuccessmsg1(false);
            setErrorMessage("");
        }
        if (errormsg1) {
            if (error26?.message?.toLowerCase() === "cannot delete specialization") {
                setErrorMessage("This specialization is associated and cannot be deleted");
            } else if (error26?.message?.toLowerCase() === "master course specialization not found") {
                setErrorMessage('This Specialization not found');
            }
            setShowErrormsg1(false);
            const ids = form.getFieldValue('specialisation');
            if (!ids.includes(delSpecID)) {
                ids.push(delSpecID);  // Add the new value if not already present
            }
            form.setFieldsValue({
                "specialisation": ids  // Update the 'specialisation' field with the new ids array
            });
        }
    }, [errormsg1, successmsg1]);

    const handleTypeChange = (e: any) => {
        setCtype(e);
        const courseSpecs = courseInfo?.data?.[0]?.specialization || [];
        if (e == "public") {
            form.setFieldValue('specialisation', '');

            if (rowData && courseSpecs.length > 0) {
                const specIdsToRemove = courseSpecs
                    .map((item: any) => item.specializationId)
                    .filter(Boolean);
               
                setRemoveSpecID((prev: number[]) => {
                    // const merged = new Set([...prev, ...specIdsToRemove]);
                    return Array.from(new Set([...prev, ...specIdsToRemove]));
                });
            }
        } else {
            form.setFieldValue('specialisation', null);
            if (rowData && courseSpecs.length > 0) {
                const specIdsToRemove = courseSpecs
                    .map((item: any) => item.specializationId)
                    .filter(Boolean);
              
                setRemoveSpecID((prev: number[]) => {
                    // const merged = new Set([...prev, ...specIdsToRemove]);
                    return Array.from(new Set([...prev, ...specIdsToRemove]));
                });
            }
        }

    }
const handleChangeSpec = (e: any) => {

    const courseSpecs = courseInfo?.data?.[0]?.specialization || [];

    const existingMasSpecIds = courseSpecs.map(
        (item: any) => item.masSpecializationId
    );

    const values = Array.isArray(e) ? e : [e];

    const matchedIds = values.filter((id: any) =>
        existingMasSpecIds.includes(id)
    );

    if (rowData && matchedIds.length > 0) {

        const specIdsToRemove = matchedIds
            .map((masId: any) => {
                return courseSpecs.find(
                    (item: any) => item.masSpecializationId === masId
                )?.specializationId;
            })
            .filter(Boolean);

        setRemoveSpecID((prev: number[]) =>
            prev.filter(id => !specIdsToRemove.includes(id))
        );
    }
}

    const handleSubjectDeselect = (e: any) => {
        const val = courseInfo?.data?.[0]?.subjects?.map((item: any) => item.masSubjectID);
        if (rowData && val?.includes(e)) {
            const val1 = courseInfo?.data?.[0]?.subjects.find((item: any) => item.masSubjectID == e)?.subjectID;
            if (!removeSubjectID?.includes(val1)) {
                setRemoveSubjectID((prevState: any) => {
                    // Make sure to create a new array with the previous state and the new value
                    return [...prevState, val1];
                });
            }
        }
    }

    const handleSubjectChange = (e: any) => {
        const val = courseInfo?.data?.[0]?.subjects?.map((item: any) => item.masSubjectID);
        const matchedSubjects = e?.filter((item: any) => val?.includes(item));
        if (rowData && matchedSubjects.length > 0) {
            // Get the corresponding subjectIDs based on the matched masSubjectID
            const subjectIDsToRemove = matchedSubjects?.map((masSubjectID: any) => {
                // Find the corresponding subjectID for each matched masSubjectID
                const subject = courseInfo.data?.[0]?.subjects?.find((item: any) => item.masSubjectID === masSubjectID);
                return subject?.subjectID; // Return the corresponding subjectID
            });

            // Remove these subjectIDs from removeSubjectID
            setRemoveSubjectID((prevState: any) => {
                // Filter out the subjectIDs that are to be removed
                return prevState.filter((id: any) => !subjectIDsToRemove.includes(id));
            });
        } else {
            setRemoveSubjectID([]);
        }

    }
    return (
        <div>
<Modal
    title={modalTitle}
    open={openModal}
    onCancel={handleCancel}
    onOk={submitForm}
    confirmLoading={loading9 || loading13 || loading16 || loading19 || loading27}
    okText={rowData ? "Update" : "Save"}
    width={700}
    bodyStyle={{
        maxHeight: "78vh",
        overflowY: "auto"
    }}
>                <Form layout="vertical" form={form} >
                    {requestFrom == 1 ?
                        <div className='row m-0'>
                            <Form.Item name="specialisationName" label="Specialization Name" className='col-md-12' rules={[{ message: "This field is required", required: true }]}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="description" label="Description" className='col-md-12'>
                                <Input />
                            </Form.Item>
                            {rowData ?
                                <Form.Item name="status" label="Status" className="col-md-12" rules={[{ required: true, message: "This field is required" }]}>
                                    <Select options={statusOption} />
                                </Form.Item> : ""}
                        </div> : requestFrom == 2 ?
                            <div className='row m-0'>
                                <Form.Item name="subjectName" label="Subject Name" className='col-md-12' rules={[{ message: "This field is required", required: true }]}>
                                    <Input />
                                </Form.Item>
                                <Form.Item name="subjectShortName" label="Subject Short Name" className='col-md-12' rules={[{ message: "This field is required", required: true }]}>
                                    <Input />
                                </Form.Item>
                                {/* <Form.Item name="type" label="Type" className='col-md-12' rules={[{ message: "This field is required", required: true }]}>
                                    <Select options={statusOption1} />
                                </Form.Item> */}
                                <Form.Item name="description" label="Description" className='col-md-12'>
                                    <Input />
                                </Form.Item>

                                {rowData ?
                                    <Form.Item name="status" label="Status" className="col-md-12" rules={[{ required: true, message: "This field is required" }]}>
                                        <Select options={statusOption} />
                                    </Form.Item> : ""}
                            </div> :
                            requestFrom == 3 ?
                                <div className='row m-0'>
                                    <Form.Item name="groupName" label="Category Name" className='col-md-12' rules={[{ message: "This field is required", required: true }]}>
                                        <Input />
                                    </Form.Item>
                                    {/* <Form.Item name="type" label="Type" className='col-md-12'>
                                        <Select options={statusOption1} />
                                    </Form.Item> */}
                                    <Form.Item name="description" label="Description" className='col-md-12'>
                                        <Input />
                                    </Form.Item>
                                    {rowData ?
                                        <Form.Item name="status" label="Status" className="col-md-12" rules={[{ required: true, message: "This field is required" }]}>
                                            <Select options={statusOption} />
                                        </Form.Item> : ""}
                                </div> : requestFrom == 4 ?
                                    <div className='row m-0'>
                                        <Form.Item name="courseName" label="Course Name" className='col-md-12' rules={[{ message: "This field is required", required: true }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name="type" label="Course Type" className='col-md-12' rules={[{
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject("This field is required"),
                                        }, { required: true, message: '' }]} >
<Select
  options={statusOption2}
  onChange={handleTypeChange}
//   disabled={!rowData}
/>
                                        </Form.Item>
                                        <Form.Item name="duration" label="Duration in hours" className='col-md-12' rules={[{
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject("This field is required"),
                                        }, { required: true, message: '' }]}>
                                            <InputNumber className='w-100' />
                                        </Form.Item>
                                        <Form.Item name="period" label="Period" className='col-md-12' rules={[{
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject("This field is required"),
                                        }, { required: true, message: '' }]}>
                                            <Select options={durationOption} />
                                        </Form.Item>
                                        <Form.Item name="category" label="Category" className='col-md-12' rules={[{
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject("This field is required"),
                                        }, { required: true, message: '' }]}>
                                            <Select options={categoryOptions}
                                                notFoundContent={
                                                    <div className="text-center p-4">
                                                        {loading18 ? (
                                                            <span>
                                                                {/* <LoadingOutlined /> */}
                                                                Loading...
                                                            </span>
                                                        ) : (
                                                            <span>No category available</span>
                                                        )}
                                                    </div>
                                                }
                                                filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                                            />
                                        </Form.Item>
                                        <Form.Item name="specialisation" label="Specialization" className={`${errorMessage ? 'mb-0' : ''} col-md-12`} rules={[{
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject("This field is required"),
                                        }, { required: true, message: '' }]}>
                                            <Select options={specializeOption}
                                                className={ctype === "Academic" ? 'custom-height-select' : ''}
                                                mode={ctype === "Public" ? undefined : "multiple"}
                                                // value={openModal ? form.getFieldValue('specialisation') : null}
                                                onDeselect={handleDeselectSpec}
                                                onChange={handleChangeSpec}
                                                notFoundContent={
                                                    <div className="text-center p-4">
                                                        {loading12 ? (
                                                            <span>
                                                                {/* <LoadingOutlined /> */}
                                                                Loading...
                                                            </span>
                                                        ) : (
                                                            <span>No specialization available</span>
                                                        )}
                                                    </div>
                                                }
                                                filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                                            />
                                        </Form.Item>
                                        <Form.Item name="subject" label="Subject" className={`${errorMessage ? 'mb-0' : ''} col-md-12`} rules={[{
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject("This field is required"),
                                        }, { required: true, message: '' }]}>
                                            <Select options={subjectOption}
                                                mode="multiple"
                                                className='custom-height-select'
                                                maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
                                                onChange={handleSubjectChange}
                                                onDeselect={handleSubjectDeselect}
                                                
                                                notFoundContent={
                                                    <div className="text-center p-4">
                                                        {loading12 ? (
                                                            <span>
                                                                {/* <LoadingOutlined /> */}
                                                                Loading...
                                                            </span>
                                                        ) : (
                                                            <span>No subject available</span>
                                                        )}
                                                    </div>
                                                }
                                                filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                                            />
                                        </Form.Item>
                                        {errorMessage ? <span className='my-2 text-danger'>{errorMessage}</span> : ""}
                                        <Form.Item name="description" label="Description" className='col-md-12'>
                                            <Input />
                                        </Form.Item>
                                        {rowData ?
                                            <Form.Item name="status" label="Status" className="col-md-12" rules={[{ required: true, message: "This field is required" }]}>
                                                <Select options={statusOption} />
                                            </Form.Item> : ""}
                                    </div> :
                                    <div className='row m-0'>
                                        <Form.Item name="syllabusTitle" label="Title" className='col-md-12' rules={[{ message: "This field is required", required: true }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name="unitNo" label="Unit Number" className='col-md-12' rules={[{
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject("This field is required"),
                                        }, { required: true, message: '' }]} >
                                            <InputNumber maxLength={2} className="w-100" />
                                        </Form.Item>

                                        <Form.Item name="course" label="Course" className={`${errorMessage ? 'mb-0' : ''} col-md-12`} rules={[{
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject("This field is required"),
                                        }, { required: true, message: '' }]}>
                                            <Select options={courseOptions}
                                                // mode={ctype === "public" ? undefined : "multiple"}
                                                // value={openModal ? form.getFieldValue('specialisation') : null}
                                                // onDeselect={handleDeselectSpec}
                                                notFoundContent={
                                                    <div className="text-center p-4">
                                                        {loading12 ? (
                                                            <span>
                                                                {/* <LoadingOutlined /> */}
                                                                Loading...
                                                            </span>
                                                        ) : (
                                                            <span>No course available</span>
                                                        )}
                                                    </div>
                                                }
                                                filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                                            />
                                        </Form.Item>
                                        <Form.Item name="subject" label="Subject" className={`${errorMessage ? 'mb-0' : ''} col-md-12`} rules={[{
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject("This field is required"),
                                        }, { required: true, message: '' }]}>
                                            <Select options={subjectOptions}
                                                // mode="multiple"

                                                notFoundContent={
                                                    <div className="text-center p-4">
                                                        {loading12 ? (
                                                            <span>
                                                                {/* <LoadingOutlined /> */}
                                                                Loading...
                                                            </span>
                                                        ) : (
                                                            <span>No subject available</span>
                                                        )}
                                                    </div>
                                                }
                                                filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                                            />
                                        </Form.Item>
                                        {errorMessage ? <span className='my-2 text-danger'>{errorMessage}</span> : ""}
                                        <Form.Item name="description" label="Notes" className='col-md-12'>
                                            <Input />
                                        </Form.Item>
                                        {/* {rowData ?
                                            <Form.Item name="status" label="Status" className="col-md-12" rules={[{ required: true, message: "This field is required" }]}>
                                                <Select options={statusOption} />
                                            </Form.Item> : ""} */}
                                    </div>}
                </Form>

            </Modal>
        </div>
    )
}

export default AddDegreeSpecialisationModal;